/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as o } from "../chunks/tslib.es6.js";
import r from "../Viewpoint.js";
import e from "../core/Accessor.js";
import { ClonableMixin as t } from "../core/Clonable.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { subclass as p } from "../core/accessorSupport/decorators/subclass.js";
import i from "../geometry/SpatialReference.js";
import { system as n } from "../time/timeZoneUtils.js";
import c from "../webdoc/RangeInfo.js";
import a from "./background/ColorBackground.js";
let m = class extends t(e) {
  constructor(o) {
    super(o), this.background = null, this.rangeInfo = null, this.spatialReference = null, this.timeZone = n, this.viewpoint = null;
  }
};
o([s({
  type: a
})], m.prototype, "background", void 0), o([s({
  type: c
})], m.prototype, "rangeInfo", void 0), o([s({
  type: i
})], m.prototype, "spatialReference", void 0), o([s({
  nonNullable: !0
})], m.prototype, "timeZone", void 0), o([s({
  type: r
})], m.prototype, "viewpoint", void 0), m = o([p("esri.webmap.InitialViewProperties")], m);
const l = m;
export { l as default };